module.exports = __webpack_public_path__ + "static/2-b38826115474a224889b794bb62753e0.gif";